import Vue from 'vue';
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

const initialRole = localStorage.getItem("userRole") || "public";
// console.log("initialRole", initialRole);

export default new AclCreate({ 
  initial: initialRole,
  notfound: "/pages/login",
  router,
  acceptLocalRules: true,
  globalRules: {
    isAdmin: new AclRule('admin').generate(),
    isUser: new AclRule('user').or('admin').generate(),
    isPublic: new AclRule('public').or('user').or('admin').generate(),
  }
})